/****************************************************
 * Module Name:  inclusionProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class InclusionProxy {
  static GetAllInclusion = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/inclusion",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleInclusion = (inclusionId, callback) => {
    let params = {
      id: inclusionId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/inclusion",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckInclusionAvailable = (inclusion, callback) => {
    let params = {
      inclusion: inclusion,
    };

    restAPICall(
      Constants.MANAGER_URL + "/inclusion/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddInclusion = (inclusion, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/inclusion",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(inclusion),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateInclusion = (inclusion, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/inclusion",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(inclusion),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteInclusion = (inclusion, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/inclusion",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(inclusion),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
